import { ACTIONS_MACHINE_MINE_PLAN } from '_constants/machineMinePlan.constants';
import machineMinePlanService from '_services/machineMinePlans.services';
import alertActions from './alert.actions';

const getIDKey = (machineMinePlan) => `${machineMinePlan.minePlanID}#${machineMinePlan.machineID}`;

const receiveMachineMinePlans = (machineMinePlans) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < machineMinePlans?.length; i++) {
    byIdObjectToDispatch[getIDKey(machineMinePlans[i])] = machineMinePlans[i];
  }

  return {
    type: ACTIONS_MACHINE_MINE_PLAN.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

const deletePlan = (minePlan) => ({
  type: ACTIONS_MACHINE_MINE_PLAN.DELETE,
  byId: { [getIDKey(minePlan)]: null }, // defaulted
});

const getAll = (accountID) => async (dispatch) => {
  try {
    const resp = await machineMinePlanService.getAll(accountID);
    dispatch(receiveMachineMinePlans(resp));
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const get = (minePlanID, machineID) => async (dispatch) => {
  try {
    const resp = await machineMinePlanService.getById(minePlanID, machineID);
    dispatch(receiveMachineMinePlans([ resp ]));
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const add = (minePlan) => async (dispatch) => {
  try {
    const resp = await machineMinePlanService.create(minePlan);
    if (resp?.minePlanID) {
      dispatch(receiveMachineMinePlans([ resp ]));
    }
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const update = (minePlan) => async (dispatch) => {
  try {
    const resp = await machineMinePlanService.update(minePlan);
    if (resp?.minePlanID) {
      dispatch(receiveMachineMinePlans([ resp ]));
    }
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const del = (minePlanID, machineID) => async (dispatch) => {
  try {
    const resp = await machineMinePlanService.del(minePlanID, machineID);
    if (resp?.minePlanID) {
      dispatch(deletePlan({ minePlanID, machineID }));
    }
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const bulkactivation = (accountID, minePlanList) => async (dispatch) => {
  try {
    await machineMinePlanService.bulkactivation(minePlanList);
    // when bulk activation completes. dispatch an action to re-fresh the redux-store state.entities.
    dispatch(getAll(accountID));
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const invalidate = () => async (dispatch) => {
  await dispatch({
    type: ACTIONS_MACHINE_MINE_PLAN.INVALIDATE,
  });
};

const machineMinePlanActions = {
  update,
  add,
  del,
  get,
  getAll,
  bulkactivation,
  invalidate,
  getIDKey,
};

export default machineMinePlanActions;
